// The server owns both authorized tax-basis summaries. Only switch their
// visibility; never calculate money or request another company's figures here.
;(function () {
  'use strict';
  if (document.documentElement.dataset.lpKpiTaxReady) { return; }
  document.documentElement.dataset.lpKpiTaxReady = 'true';
  document.addEventListener('change', function (event) {
    if (!event.target.matches('.lp-business-overview .lp-kpi-tax-toggle')) { return; }
    var root = event.target.closest('.lp-business-overview');
    var basis = event.target.checked ? 'inclusive' : 'exclusive';
    root.querySelectorAll('.lp-kpi-tax-panel').forEach(function (panel) {
      panel.hidden = panel.dataset.tax !== basis;
    });
  });
})();

// Open the authorized discussion when a home-page composer receives focus.
// Native comment code remains the owner of fetching, channels and posting.
;(function () {
  'use strict';
  if (document.documentElement.dataset.lpFeedCommentsReady) { return; }
  document.documentElement.dataset.lpFeedCommentsReady = 'true';
  var pending = new WeakMap();
  document.addEventListener('focusin', function (event) {
    var input = event.target;
    if (!input.matches || !input.matches('#landing .lxpComments .postForm > textarea')) { return; }
    var root = input.closest('.lxpComments');
    var host = root.parentElement;
    if (!window.lx || !lx.comment || pending.has(host)) { return; }
    var channel = host.getAttribute('data-tabopen');
    var tab = channel === 'Internal' || channel === 'Shared'
      ? root.querySelector('.SR_lxCommentsTab' + channel + '_tab a') : null;
    // Some feed records render a composer for Shared without an authorized Shared tab.
    // Select only a channel that the server actually rendered for this record.
    if (!tab) {
      tab = root.querySelector('.SR_lxCommentsTabInternal_tab a, .SR_lxCommentsTabShared_tab a');
      if (!tab) { return; }
      channel = tab.getAttribute('aria-controls').replace('SR_lxCommentsTab', '');
    }
    var needsFetch = host.getAttribute('data-fetch') === '1';
    if (needsFetch) {
      var start = input.selectionStart;
      var end = input.selectionEnd;
      var observer = new MutationObserver(function () {
        var replacement = host.querySelector('.postForm > textarea');
        if (!replacement || replacement === input || host.getAttribute('data-fetch') === '1') { return; }
        // Preserve any typing made while the native request was pending.
        replacement.value = input.value;
        var restoreFocus = document.activeElement === input || document.activeElement === document.body;
        cleanup();
        if (restoreFocus) {
          replacement.focus({preventScroll:true});
          replacement.setSelectionRange(input.selectionStart == null ? start : input.selectionStart,
            input.selectionEnd == null ? end : input.selectionEnd);
        }
      });
      function cleanup() { observer.disconnect(); clearTimeout(timer); pending.delete(host); }
      var timer = setTimeout(cleanup, 15000);
      pending.set(host, observer);
      observer.observe(host, {childList:true, subtree:true});
    }
    if (!tab.parentElement.classList.contains('is-active')) {
      lx.comment.changeTab(tab);
    } else if (needsFetch) {
      lx.comment.setOptions(host.id);
      lx.comment.fetchComments(host.id);
    } else {
      var panel = root.querySelector('.SR_lxCommentsTab' + channel);
      if (panel) { panel.style.display = ''; panel.setAttribute('aria-hidden', 'false'); }
    }
  });
})();

// Feed-only audience names and a recognizable, labeled Like action. Native
// channel identifiers, authorization, counts and submission handlers stay intact.
;(function () {
  'use strict';
  if (document.documentElement.dataset.lpFeedAudienceReady) { return; }
  document.documentElement.dataset.lpFeedAudienceReady = 'true';
  var hr = /^hr(?:-|$)/i.test(document.documentElement.lang || '');
  var words = hr ? {
    team:'Timska rasprava', public:'Komentari', comments:'Komentari',
    teamHelp:'Razgovarajte s timom o ovom zapisu.',
    publicHelp:'Komentirati mogu osobe koje vide ovu objavu, uključujući osobe izvan vašeg tima.',
    recordHelp:'Vidljivo osobama koje imaju pristup ovom zapisu.',
    like:'Sviđa mi se', liked:'Sviđa vam se'
  } : {
    team:'Team discussion', public:'Comments', comments:'Comments',
    teamHelp:'Discuss this record with your team.',
    publicHelp:'Anyone who can view this post can comment, including people outside your team.',
    recordHelp:'Visible to people who can access this record.',
    like:'Like', liked:'Liked'
  };
  function setText(node, text) { if (node && node.textContent !== text) { node.textContent = text; } }
  function setAttr(node, key, value) { if (node.getAttribute(key) !== value) { node.setAttribute(key, value); } }
  function decorate() {
    // Native About content is fetched lazily. Give its icon-only links real
    // accessible names without changing user-maintained URLs or targets.
    var networks = {linkedin:'LinkedIn', facebook:'Facebook', twitter:'X / Twitter', youtube:'YouTube', instagram:'Instagram', vimeo:'Vimeo'};
    document.querySelectorAll('#landing #lxpTAB-about-container .share-badges > a').forEach(function (link) {
      var icon = link.querySelector('.social-icon');
      if (!icon) { return; }
      Object.keys(networks).some(function (network) {
        if (!icon.classList.contains(network)) { return false; }
        setAttr(link, 'aria-label', networks[network]); setAttr(link, 'title', networks[network]);
        return true;
      });
    });
    document.querySelectorAll('#landing .lxpComments').forEach(function (root) {
      var post = !!root.closest('.lxArt');
      ['Internal', 'Shared'].forEach(function (channel) {
        var link = root.querySelector('.SR_lxCommentsTab' + channel + '_tab a');
        if (!link) { return; }
        var label = channel === 'Internal' ? words.team : (post ? words.public : words.comments);
        var help = channel === 'Internal' ? words.teamHelp : (post ? words.publicHelp : words.recordHelp);
        setText(link.querySelector('span:first-child'), label);
        setAttr(link, 'title', help);
        var panel = root.querySelector('.SR_lxCommentsTab' + channel);
        if (panel) { setAttr(panel, 'data-label', label); }
      });
      var form = root.querySelector('.postForm');
      if (form) {
        var active = root.querySelector('.is-active > a[aria-controls]');
        var helpText = active ? active.getAttribute('title') : '';
        var guidance = form.querySelector('.lp-feed-audience');
        if (helpText && !guidance) {
          guidance = document.createElement('p'); guidance.className = 'lp-feed-audience';
          form.insertBefore(guidance, form.firstChild);
        }
        if (guidance) { setText(guidance, helpText || ''); guidance.hidden = !helpText; }
      }
      root.querySelectorAll('.art-reaction').forEach(function (reaction) {
        var icon = reaction.querySelector('i.fawe-thumbs-up');
        if (!icon) { return; }
        var liked = icon.classList.contains('lxBookmarkIconFullL');
        var label = reaction.querySelector('.lp-feed-like-label');
        if (!label) {
          label = document.createElement('span'); label.className = 'lp-feed-like-label';
          reaction.insertBefore(label, reaction.querySelector('.badge'));
        }
        setText(label, liked ? words.liked : words.like);
        setAttr(reaction, 'role', 'button'); setAttr(reaction, 'tabindex', '0');
        setAttr(reaction, 'aria-pressed', liked ? 'true' : 'false');
      });
    });
  }
  function start() {
    var landing = document.getElementById('landing');
    if (!landing) { return; }
    var queued = false;
    new MutationObserver(function () {
      if (queued) { return; }
      queued = true;
      requestAnimationFrame(function () { queued = false; decorate(); });
    }).observe(landing, {childList:true, subtree:true, attributes:true, attributeFilter:['class']});
    landing.addEventListener('keydown', function (event) {
      if ((event.key === 'Enter' || event.key === ' ') && event.target.matches('.art-reaction[role="button"]')) {
        event.preventDefault(); event.target.click();
      }
    });
    decorate();
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start, {once:true}); }
  else { start(); }
})();

